import React, { useRef } from 'react';
import classNames from 'classnames';
import { List, Map } from 'immutable';

import { Paragraph, ImageFromField } from '@uncinc/react-drupal-core';

import {
  Container,
  WysiwygField,
  Button,
  ScrollIndicator,
} from '../../../components';

import {
  SCREEN_MOBILE,
  SCREEN_TABLET,
  SCREEN_NORMAL,
  SCREEN_WIDE,
} from '../../../config/constants';

import './style.scss';

const NodeCampaignPage = ({ entity, className }) => {

  const title = entity.getIn(['title', 0, 'value']);
  const description = entity.getIn(['body', 0, 'processed']);
  const headerImage = entity.getIn(['field_header_image', 0]);
  const ctaLabel = entity.getIn(['field_call_to_action_label', 0, 'value']);
  const wrapperRef = useRef(null);


  const primaryLinkContent = {
    uri: entity.getIn(['field_primairy_link', 0, 'uri']), 
    label: entity.getIn(['field_primairy_link', 0, 'title']), 
  }
  
  const classes = classNames(
    className,
    'CampaignPage',
    'u-margin--bottom--10',
  );

  return (
    <>
    <ScrollIndicator scrollAreaRef={wrapperRef} />
    <article className={classes} ref={wrapperRef}>
      <div className='CampaignPage__header-image-wrapper'>
        {headerImage && 
          <ImageFromField 
            field={headerImage}
            imageStyles={Map({
              [SCREEN_MOBILE]: 'crop_hero',
              [SCREEN_TABLET]: 'crop_hero',
              [SCREEN_NORMAL]: 'crop_hero',
              [SCREEN_WIDE]: 'crop_hero',
            })}
            lazyload
          />}
      </div>
        <Container>

          <div className="u-margin--bottom--10 CampaignPage__header u-padding--bottom--9 u-padding--top--9 d-flex flex-wrap justify-content-between">
            <div className="CampaignPage__header-inner d-flex flex-wrap">
              <h1>{title}</h1>
              {description ? (
                <div >
                  <WysiwygField
                    property="schema:text"
                    className="text-large node--basic-page--body flex-fill"
                    html={description}
                  />
                </div>
              ) : null}
            </div>

            <div className="d-flex flex-wrap CampaignPage__button-wrapper align-self-end">
              <Button type="primary" href="#contact-form">{ctaLabel}</Button>
              <Button type="secondary" href={primaryLinkContent.uri}>{primaryLinkContent.label}</Button>
            </div>

          </div>
          {entity.get('field_paragraphs') ? (
            <div className="node--page--paragraphs-wrapper">
              {entity.get('field_paragraphs', List()).map((paragraph) => {
                const id = paragraph.get('target_id');
                const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
                return (
                  <Paragraph
                    key={`paragraph:${id}:${language}`}
                    id={id}
                    entity={paragraph.get('entity')}
                  />
                );
              })}
            </div>
          ) : null}
        </Container>
    </article>
    </>
  );
};

export default NodeCampaignPage;
